import { GetRegistrationModel } from "@factory/model/query-model-registration";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { registrationFormDefault } from "./form.default";
import { RegistrationFormSchema } from "./form.rule";

export const useFormDefaultRegistration = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRegistrationModel | undefined) => {
    return !cachedValue
      ? registrationFormDefault
     : ({
        tenant: cachedValue.tenant,
        branch: cachedValue.branch,
        cardCategory: cachedValue.card_category,
        firstName: cachedValue.first_name,
        middleName: cachedValue.middle_name,
        lastName: cachedValue.last_name,
        gender: cachedValue.gender,
        birthday: cachedValue.birthday,
        username: cachedValue.username,
        email: cachedValue.email,
        mobileNumber: cachedValue.mobile_number,
        avatar: cachedValue.avatar,
        expiration: cachedValue.expiration,
        status: cachedValue.status,
        remarks: cachedValue.remarks,
        referralCode: cachedValue.referral_code,
      } as RegistrationFormSchema);
  };

  return {
    getDefault,
  };
};
